import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=3da373e3&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=3da373e3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da373e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da373e3')) {
      api.createRecord('3da373e3', component.options)
    } else {
      api.reload('3da373e3', component.options)
    }
    module.hot.accept("./MyOrders.vue?vue&type=template&id=3da373e3&scoped=true", function () {
      api.rerender('3da373e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyOrders.vue"
export default component.exports